import styled from 'styled-components';
import { Typ31 } from '../Typ';
import IcoW01 from '../IcoW01';

export const ElementWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  background: transparent;
  position: relative;
  max-width: 100%;
  padding: 12px 16px 15px;
`;

export const TitleText = styled(Typ31)`
  color: #263238;
`;

export const RightIcon = styled(IcoW01)`
  cursor: pointer;
  color: #90a4ae;
  &:hover {
    color: #607d8b;
  }
`;

export const LeftIcon = styled(IcoW01)`
  cursor: pointer;
  color: #90a4ae;
  &:hover {
    color: #607d8b;
  }
`;
